<script></script>

<div class="flex justify-center mb-20 ">
    <div class="min-[320]:px-10 md:w-1/2 shadow rounded-lg px-7 py-3">
        <div class="font-bold">About Us</div>
        <p class="py-1">
            Better Life Uganda is a platform of Golden Voice Foundation Africa
            Founded by Nuwasasira Emmanuel aka E.J Nuwasasira.
        </p>

        <p class="py-1">
            Through therapy, mentorship, wellness camps, and many more programs,
            we help you overcome your social anxiety, deal with stress, and make
            healthy choices.
        </p>
        Mental health includes our emotional, psychological, and social well-being.
        It affects how we think, feel, and act.
        <p class="py-1">
            It's important at every stage of life, from childhood and
            adolescence through adulthood.  
        </p>
        <p class="py-1 text-center font-bold">
            Better Life Uganda Cares.
        </p>
        
    </div>
</div>
